import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import OutOfStockPrompt from '../scanToCart/OutOfStockConfirmPrompt';
import { useDispatch, useSelector } from 'react-redux';
import { setIsCartView, sortUnScannedItems, setUnScannedItems, findToteForNextItem, setNextPickItem, setShowOutOfStockPrompt } from '../../actions/scanToCartActions';
import { handleViewItem, setMainInputFocus } from '../../actions/ScanToCartScanningActions';
import { isNotFullFilledItem } from './utils/scanningUtils';
import Toast, { useToast } from '../../commons/Toast';
import I18n from 'i18n-js';

const StockComponents = () => {
  const [isReversePickList, setIsReversePickList] = useState(false);
  const showOutOfStockPrompt = useSelector(state => state.scanToCart.showOutOfStockPrompt);
  const isCartView = useSelector(state => state.scanToCart.isCartView);
  const nextPickItem = useSelector(state => state.scanToCart.nextPickItem);
  const notFullFilledItems = useSelector(state => state.scanToCart.notFullFilledItems);
  const isNotFulfilled = isNotFullFilledItem(notFullFilledItems, nextPickItem?.item);
  const user = useSelector(state => state.user.userInfo);
  const unScannedItems = useSelector(state => state.scanToCart.unScannedItems);
  const toteAssignments = useSelector(state => state.scanToCart.toteAssignments);
  const { showToast, toastMessage, showToastMessage, hideToast } = useToast();

  const dispatch = useDispatch();

  const getStorageKey = () => {
    if (user && user.current_tenant && user.name) {
      return `${user.current_tenant}-${user.name}-reversePickList`;
    }
    return 'reversePickList';
  };

  useEffect(() => {
    const storageKey = getStorageKey();
    const storedValue = localStorage.getItem(storageKey);
    if (storedValue === 'true') {
      setIsReversePickList(true);
    }
  }, [user]);

  const getActions = () => {
    return [
      'Report Stock',
      // 'Transfer Inventory', //not need as of now, will enable later
      isCartView ? 'View Item' : 'View Cart >>',
      I18n.t('reversePickList.buttonLabel')
    ];
  };

  const handleReversePickListToggle = () => {
    const newValue = !isReversePickList;
    setIsReversePickList(newValue);
    const storageKey = getStorageKey();
    localStorage.setItem(storageKey, newValue.toString());

    const sortedItems = sortUnScannedItems([...unScannedItems], newValue);
    dispatch(setUnScannedItems(sortedItems));

    const currentItem = nextPickItem?.item;
    const hasScannedQty = currentItem?.scanned_qty > 0;

    if (!hasScannedQty) {
      const newNextPickItem = findToteForNextItem(sortedItems, toteAssignments);
      if (newNextPickItem) {
        dispatch(setNextPickItem(newNextPickItem));
      }
    }

    showToastMessage(newValue ? I18n.t('reversePickList.toastReversed') : I18n.t('reversePickList.toastRestored'));
  };

  const handlePress = (action) => {
    switch (action) {
      case 'Report Stock':
        dispatch(setMainInputFocus(false));
        dispatch(setShowOutOfStockPrompt(true));
        break;
      case 'View Cart >>':
        dispatch(setIsCartView(true));
        break;
      case 'View Item':
        dispatch(handleViewItem());
        break;
      case 'Reverse Pick List':
        handleReversePickListToggle();
        break;
      default:
        break;
    }
  };



  return (
    <View style={styles.container}>
      {getActions().map((action, index) => (
        <React.Fragment key={index}>
          {!(isNotFulfilled && action === 'Report Stock') && (
            <TouchableOpacity
              testID={action.replace(/\s+/g, '').replace('>>', '')}
              style={styles.button}
              onPress={() => handlePress(action)}
              activeOpacity={0.8}
            >
              <View style={styles.buttonContent}>
                <Text style={styles.buttonText}>{action}</Text>
                {action === 'Reverse Pick List' && (
                  <i
                    className="icon-updown-circle"
                    style={{
                      color: isReversePickList ? '#000' : '#ffffff',
                      fontSize: '16px',
                      marginLeft: '8px'
                    }}
                  ></i>
                )}
              </View>
            </TouchableOpacity>
          )}
        </React.Fragment>
      ))}

      {showOutOfStockPrompt && <OutOfStockPrompt
        showPrompt={showOutOfStockPrompt}
        setShowPrompt={(value) => dispatch(setShowOutOfStockPrompt(value))}
      />}
      <Toast
        visible={showToast}
        message={toastMessage}
        onHide={hideToast}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal: 12,
    paddingVertical: 9,
    gap: 12,
    zIndex: 9999,
    position: 'relative',
  },
  button: {
    borderWidth: 1,
    borderColor: '#ffffff',
    borderRadius: 15,
    paddingHorizontal: 10,
    paddingVertical: 4,
    backgroundColor: 'transparent',
  },
  buttonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    fontFamily: 'Poppins_300Light',
    color: '#ffffff',
    fontSize: 16,
    textAlign: 'center',
  },
});

export default StockComponents;
